import React from 'react';
import FundingDetail from '../components/funding/FundingDetail';

const FundingDetailPage = () => {
  return <FundingDetail />;
};

export default FundingDetailPage;